/*
 * Created Date: Tue, 15th Dec 2020, 10:59:10 am
 * Author: Kristyna Fojtikova
 * Email: kristyna.fojtikova@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  TopToolbar,
  sanitizeListRestProps,
  useDataProvider,
  CreateButton,
} from 'react-admin';
import { Help } from '@material-ui/icons';
import { LinkButton } from 'Components/Buttons';
import getHelp from '../../utils/getHelp';

const SitesActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter = false, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  hasCreate, // you can hide CreateButton if hasCreate = false
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  ...rest
}) => {
  const dataProvider = useDataProvider();
  const dispatch = useDispatch();
  const [helpLink, setHelpLink] = useState();

  const useMountEffect = fun => useEffect(fun, []);
  useMountEffect(
    getHelp('help_url_site', { dataProvider, dispatch, setHelpLink })
  ); // run once

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {helpLink && (
        <LinkButton
          label="resources.General.help"
          pathname="/"
          icon={<Help />}
          noStyles={true}
        />
      )}
      <CreateButton basePath={basePath} />
    </TopToolbar>
  );
};

SitesActions.defaultProps = {
  selectedIds: [],
  onUnselectItems: () => null,
};

export default SitesActions;
